module.exports = __webpack_public_path__ + "img/header-weddingRingsRosegold@2x.80d0c3f.jpg";